import { post } from './apiService';

export const getAllSystems = async (token) => {
  const data = {'token': token}
  return await post('services', data);
};